import { useState } from "react";

/** A failed provider advances to the next candidate; new URLs reset failures. */
export function IdentityImage({ image, avatarUrls, fit = "cover" }: {
  image?: string | null; avatarUrls?: string[]; fit?: "cover" | "contain";
}) {
  const urls = [...new Set([image, ...(avatarUrls ?? [])].filter((url): url is string => Boolean(url)))];
  return <ImageCandidates key={JSON.stringify(urls)} urls={urls} fit={fit} />;
}
function ImageCandidates({ urls, fit }: { urls: string[]; fit: "cover" | "contain" }) {
  const [index, setIndex] = useState(0);
  if (!urls[index]) return null;
  return <img src={urls[index]} alt="" referrerPolicy="no-referrer" onError={() => setIndex((i) => i + 1)}
    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: fit, background: "var(--surface-3)" }} />;
}
